export const sortOptions = [
  { id: 'rating', label: 'catFilter.bwRating' },
  { id: 'popularity', label: 'catFilter.popularity' },
  // { id: 'customerSatisfaction', label: 'catFilter.customerSatisfaction' },
];
